<div class="head drop-target" [class.drop]="fall()">
    <a [routerLink]="'/index'" class="title">
        <span class="logo"><img src="/assets/image/logo-mando-white.svg"></span>
    </a>
</div>
